import script from "./LinkTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./LinkTopComponent.vue?vue&type=style&index=0&id=664b2192&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664b2192"]])

export default __exports__